export default __webpack_public_path__ + "static/media/download.16377239.svg";